import React from 'react'
import InapporopriateContent from "../../assets/images/Layer_1.svg"
import SuggestionButton from "../buttons/SuggestionButton"
import suggestionPrompt from "../../assets/data/suggestionPrompt.json"
import surpriseMePrompt from '../../assets/data/surpriseMePrompt.json'
import { useDispatch, useSelector } from 'react-redux'
import { setPrompt } from '../../redux/promptSlice'
import Button from '../buttons/Button'
import { setClearFontError } from '../../redux/fontListSlice'
import { resetErrorState, setIsVisualizePageVisible } from '../../redux/createImageSlice'
import { useFetchFonts } from '../../services/fontListService'
import { useGenerateImages } from '../../services/imageService'

const FontError = ({ title, subtitle }) => {
    const dispatch = useDispatch()
    const { fetchFonts } = useFetchFonts();
    const generateImages = useGenerateImages();

    const { recommendedFontList } = useSelector((state) => state.fontList)

    const editPromptHandler = () => {
        if (recommendedFontList.length > 0) {
            dispatch(setClearFontError())
        } else {
            dispatch(setClearFontError())
            dispatch(setIsVisualizePageVisible(true))
        }
        dispatch(resetErrorState())
    }

    const handlePromptClick = async (prompt) => {
        let promptId = "new"
        dispatch(setPrompt(prompt));
        dispatch(setIsVisualizePageVisible(false))
        let font = await fetchFonts(prompt);
        await generateImages(promptId, prompt, font)
    }

    const surpriseMeHandler = async () => {
        let promptId = "new"
        const randomIndex = Math.floor(Math.random() * surpriseMePrompt.length);
        let prompt = surpriseMePrompt[randomIndex];
        dispatch(setPrompt(prompt));
        dispatch(setIsVisualizePageVisible(false))
        let font = await fetchFonts(prompt);
        await generateImages(promptId, prompt, font)
    }

    return (
        <div className='h-[calc(100vh-80px)] w-full'>
            <div className='h-full flexCenter flex-col gap-[48px]'>
                <img src={InapporopriateContent} alt="Inapporopriate Content" />
                <div className='h-[176px] text-center flexCenter flex-col gap-[24px]'>
                    <h1 className='text-[#313945] font-helveticaDisp-Bold text-[40px] font-[700] leading-[48px] tracking-[-0.02em]'> {title} </h1>
                    <p className='text-[23px] text-secondary'>{subtitle}</p>
                    <Button onClick={editPromptHandler} label='Edit prompt' className="w-fit bg-blue-primary hover:bg-blue-dark text-white px-[48px] " />
                </div>
                <div className='h-[72px] flexCenter flex-col gap-[8px]'>
                    <p className='text-[#667488]'>While we send our AI to a unique words training camp, you can try these...</p>
                    <div className='w-fit flex gap-[8px]'>
                        {suggestionPrompt.map((item, index) => (
                            <SuggestionButton key={index} onClick={() => handlePromptClick(item)}>{item}</SuggestionButton>
                        ))}
                        <div className='w-fit flex flex-col gap-[8px]'>
                            <SuggestionButton onClick={surpriseMeHandler}>Surprise me</SuggestionButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FontError